import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';
import styled from 'styled-components';
import { CustomCellRendererProps } from 'ag-grid-react';
import { AbbreviationNumberFilter } from './AbbreviationNumberFilter';
import { formatCellValueOrDefault, getCellValueOrDefault } from '../helpers';

export const NumberColDef = (colDef: AdvancedColDef): AdvancedColDef => ({
  cellStyle: { textAlign: 'right' },
  filter: AbbreviationNumberFilter,
  valueFormatter: colDef.valueFormatter ?? formatCellValueOrDefault,
  valueGetter: colDef.valueGetter ?? getCellValueOrDefault,
  ...colDef,
  ...absColDef({
    ...colDef,
    ...absColDef(colDef),
  }),
});

const NumbeColDefRender: React.FC<CustomCellRendererProps> = params => {
  const val = params.value ?? '--';
  return (
    <Span fontSize={13} fontWeight={500}>
      {val === '--' ? val : val > 0 ? <Positive>{val}%</Positive> : val < 0 ? <Negative>{val}%</Negative> : `${val}%`}
    </Span>
  );
};

export const NumbeColDefV2 = (colDef: AdvancedColDef): AdvancedColDef => ({
  cellRenderer: NumbeColDefRender,
  cellStyle: { 'text-align': 'left' },
  filter: 'agNumberColumnFilter',
  ...colDef,
  ...absColDef(colDef),
});

const Span = styled.span<{
  fontWeight?: number;
  fontSize?: number;
}>`
  display: flex;
  justify-content: start;
  align-items: center;
  font-weight: ${props => props.fontWeight || 600};
  font-size: ${props => props.fontSize || 13}px;
  font-family: 'Nimbus Sans D OT-Bold', Helvetica;
  height: 100%;
`;

const Positive = styled.span`
  color: ${({ theme }) => theme.colors.statistic.positive} !important;
  fill: ${({ theme }) => theme.colors.statistic.positive} !important;
`;

const Negative = styled.span`
  color: ${({ theme }) => theme.colors.statistic.negative} !important;
  fill: ${({ theme }) => theme.colors.statistic.negative} !important;
`;
